@use '../../scss/utility/functions' as utility;

:host(:not(:focus-within)) {
  position: absolute !important;
  width: utility.wb-pixel-to-rem(1px) !important;
  height: utility.wb-pixel-to-rem(1px) !important;
  border: 0 !important;
  padding: 0 !important;
  white-space: nowrap !important;
  clip-path: inset(100%) !important;
  clip: rect(0 0 0 0) !important;
  overflow: hidden !important;
}
